import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { SafeHtmlModule } from '@shared/pipes';
import { EmptyStateComponent } from './empty-state.component';

@NgModule({
  declarations: [EmptyStateComponent],
  imports: [CommonModule, SafeHtmlModule],
  exports: [EmptyStateComponent],
})
export class EmptyStateModule {}
